import logo from "../assets/logo.jpeg"; // adjust path to your logo asset

let cachedBase64Logo = null;

export const getBase64Logo = async () => {
  // ✅ Return cached version if already converted
  if (cachedBase64Logo) return cachedBase64Logo;

  // ✅ Fetch the image blob and convert it to base64
  const response = await fetch(logo);
  const blob = await response.blob();

  const reader = new FileReader();
  return new Promise((resolve) => {
    reader.onloadend = () => {
      cachedBase64Logo = reader.result; // cache it
      resolve(cachedBase64Logo);
    };
    reader.readAsDataURL(blob);
  });
};
